const getBaseUrl = (): string => {

  const buildBase = import.meta.env.VITE_APP_BASE_URL;      // for production only
  // const buildBase = import.meta.env.VITE_APP_BASE_URL_TEST;  //for testing only

  if (buildBase && typeof buildBase === "string" && buildBase.length > 0) {
    return buildBase.replace(/\/+$/, ""); // Remove trailing slashes
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  return buildBase || "http://localhost:3000" || "http://localhost:4173";
};

export default getBaseUrl;
